module.exports = __webpack_public_path__ + "img/icon-kxhd.35057bf0.png";